module.exports = __webpack_public_path__ + "media/images/icons/heart-like-ee7e03e929265ccc893cd58b175af4f4.svg";